module.exports = __webpack_public_path__ + "static/media/vectors.ceb9ffeb.svg";